﻿import * as Res from "./res";
import { getApiConfig } from "./context";
import { createElement } from "./_dom";
import { getRootUrl } from "./context";
import { hubConnection } from "../../../node_modules/@jamiecurnow/signalr-no-jquery/lib/signalR.js";

/** @param progress {HTMLElement} */
function generateDocument(progress) {

	function back() {
		location.replace(getApiConfig("backUrl"));
	}

	function download(url) {
		progress.after(createElement("iframe", { id: "td-downloader", class: "v3-downloader-frame invisible", src: url }));
	}

	const url = progress.dataset.gendocMulti;

	const progressValue = progress.querySelector(".v3-progressreport__progress .v3-progressbar__value");
	const progressMeter = progress.querySelector(".v3-progressbar");
	const progressMessage = progress.querySelector(".v3-progressreport__message");
	const cancelButton = progress.querySelector(".v3-progressreport__action");

	progressMessage.classList.add("ui-icon-spinner");
	cancelButton.addEventListener("click", back);

	var did = +new URLSearchParams(url.substring(url.indexOf("?") + 1)).get("d");

	var currentTaskId = "doc-" + did + "-" + new Date().valueOf();

	var connection = hubConnection(getRootUrl(progress));
	connection.createHubProxy("progressHub").on("notifyProgress", (taskId, i, l) => {
		if (currentTaskId === taskId) {
			var p = l ? (i / l * 100) : 0;
			if (i < 999999) {
				progressMeter.style.setProperty("--v3-progress-value", p);
				progressValue.replaceChildren(p.toFixed(0) + "%");
				progressMessage.replaceChildren(String.format(Res.getString("action.progress_text"), i + 1, l));
			}
			else if (i === 999999) {
				progressMessage.replaceChildren(Res.getString("document.rendering"));
			} else {
				progressMessage.classList.remove("ui-icon-spinner");
				cancelButton.replaceChildren(Res.getString("action.done"));
				if (i === 1000001) {
					progressMessage.replaceChildren(Res.getString("document.error.no_records"));
				} else {
					progressMessage.replaceChildren(Res.getString("document.download"));
					setTimeout(back, 3000);
				}
			}
		}
	});

	connection.start()
		.done(() => {
			var connectionId = connection.id;
			download(url + "&task=" + encodeURIComponent(currentTaskId) + "&conn=" + encodeURIComponent(connectionId));
		})
		.fail(() => {
			progressValue.replaceChildren(Res.getString("document.error.no_progress"));
			progressMessage.replaceChildren();
			download(url);
		});
}

function init(context) {
	// there should be no more than one
	const progress = context.querySelector("[data-gendoc-multi]");
	if(progress)
		generateDocument(progress);
}

export { init };